import { render, staticRenderFns } from "./quick.vue?vue&type=template&id=56286caa&scoped=true"
import script from "./quick.vue?vue&type=script&lang=js"
export * from "./quick.vue?vue&type=script&lang=js"
import style0 from "./quick.vue?vue&type=style&index=0&id=56286caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56286caa",
  null
  
)

export default component.exports